// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"c677cc9b","653":"ab971016","707":"ce99023a"}[chunkId] + ".chunk.js";
};